export const SOME = 'SOME';
export const NONE = 'NONE';